import { css } from "@emotion/core";
import PulseLoader from "react-spinners/PulseLoader";
import styled from "styled-components";

const customCss = css`
  margin: 3px;
  padding-top: 5px;
  text-align: center;
`;

const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent || "center"};
  align-items: ${({ alignItems }) => alignItems || "center"};
  margin: ${({ margin }) => margin || "0"};
`;

const LoadingText = styled.div`
  font-size: ${({ fontSize }) => fontSize || `16px`};
  font-weight: ${({ fontWeight }) => fontWeight || `600`};
  color: ${({ color }) => color || "#fff"};
`;

const TextLoader = ({ size = 4, color = "#fff", loading }) => {
  return (
    <div className="sweet-loading">
      <PulseLoader
        size={size}
        color={color}
        loading={loading}
        css={customCss}
      />
    </div>
  );
};

const ButtonTextLoader = ({
  justifyContent,
  margin,
  alignItems,
  fontSize = "16px",
  fontWeight = "600",
  color = "#fff",
  loadingText = "Loading",
  size,
}) => {
  return (
    <LoaderContainer
      justifyContent={justifyContent}
      margin={margin}
      alignItems={alignItems}
    >
      <LoadingText fontSize={fontSize} fontWeight={fontWeight} color={color}>
        {loadingText}
      </LoadingText>
      <TextLoader size={size} loading color={color} />
    </LoaderContainer>
  );
};

export default ButtonTextLoader;
